// Shared YouTube IFrame API and URL helpers

let ytApiPromise;

export function loadYouTubeApi() {
  if (window.YT && window.YT.Player) return Promise.resolve();
  if (ytApiPromise) return ytApiPromise;
  ytApiPromise = new Promise((resolve, reject) => {
    const prev = window.onYouTubeIframeAPIReady;
    window.onYouTubeIframeAPIReady = () => { if (typeof prev === 'function') prev(); resolve(); };
    const s = document.createElement('script');
    s.src = 'https://www.youtube.com/iframe_api';
    s.onerror = () => { ytApiPromise = undefined; reject(new Error('YT API load failed')); };
    document.head.appendChild(s);
  });
  return ytApiPromise;
}

export function ytVideoId(url) {
  const m = String(url || '').match(/(?:embed\/|v=|v\/|youtu\.be\/)([\w-]{11})/);
  return m ? m[1] : null;
}

export function isYouTube(url) {
  try {
    const h = new URL(url).hostname.replace(/^www\./, '');
    return h === 'youtube.com' || h === 'm.youtube.com' || h === 'youtu.be';
  } catch {
    return false;
  }
}
